import { TimeTrackingService } from "@/common/api.service";
import { FETCH_TIME_TRACKING_DATA, EDIT_TIME_TRACKING_DATA, DELETE_TIME_TRACKING_DATA, CREATE_TIME_TRACKING_DATA, CANCEL_TIME_TRACKING_DATA, RESET_STATE } from "./actions.type";
import { SET_TIME_TRACKING_DATA, SET_TIME_TRACKING_ERROR, STATE_RESET } from "./mutations.type";

const initialState = () => {
    return {
        timetrackingdata: [],
        timetrackingerror: [],
    }
};

export const state = initialState()

const actions = {

    async [FETCH_TIME_TRACKING_DATA](context, slug) {
        return await TimeTrackingService.get(slug).then(response => {
            context.commit(SET_TIME_TRACKING_DATA, response.data)
            return response
        }).catch(({ response }) => {
            context.commit(SET_TIME_TRACKING_ERROR, response.errorMessage)
            return response
        })
    },

    async [CREATE_TIME_TRACKING_DATA](context, slug) {
        return await TimeTrackingService.create(slug.slug, slug.params).then((response) => {
            return response
        }).catch(({ response }) => {
            context.commit(SET_TIME_TRACKING_ERROR, response.data.errorMessage)
            return response
        })
    },

    async [CANCEL_TIME_TRACKING_DATA](context, slug) {
        return await TimeTrackingService.create(slug.slug, slug.params).then((response) => {
            return response
        }).catch(({ response }) => {
            context.commit(SET_TIME_TRACKING_ERROR, response.data.errorMessage)
            return response
        })
    },

    async [EDIT_TIME_TRACKING_DATA](context, slug) {
        return await TimeTrackingService.update(slug.slug, slug.params).then((response) => {
            return response
        }).catch(({ response }) => {
            context.commit(SET_TIME_TRACKING_ERROR, response.data.errorMessage)
            return response
        })
    },

    async [DELETE_TIME_TRACKING_DATA](context, slug) {
        return await TimeTrackingService.destroy(slug).then((response) => {
            return response
        }).catch(({ response }) => {
            context.commit(SET_TIME_TRACKING_ERROR, response.data.errorMessage)
            return response
        })
    },

    [RESET_STATE]({ commit }) {
        commit(STATE_RESET)
    }

}

const mutations = {

    [SET_TIME_TRACKING_DATA](state, timetrackingdata) {
        state.timetrackingdata = timetrackingdata
    },
    [SET_TIME_TRACKING_ERROR](state, error) {
        state.timetrackingerror = error
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }

}

const getters = {

    timetrackingdata(state) {
        return state.timetrackingdata.sort((a, b) => Number(b.startTime) - Number(a.startTime));
    },

}

export default {
    state,
    getters,
    actions,
    mutations
};